import { Box, Chip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-premium";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { stockAdjustmentPagingAPI } from "../../../api/url";
import { DynamicCatalogBuilder } from "../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder";
import { DesktopTabComponent } from "../../../components/molecules/desktopTabComponent";
import { ESystemName, LOCAL_STORAGE_KEYS } from "../../../constants";
import { useAppSelector } from "../../../store/hooks";
import { secondaryTextGray } from "../../../theme/palette";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { dateFormate } from "../../../utils/utils";
import { CancelIconSVG, DownloadIconSVG, EditIconSVG, PrintIconSVG, ShareOutlinedIconSVG } from "../../spareParts/purchaseRequistion/assets/customIcons";
import { StockAdjustmentPaging } from "../apiCall";
import { StockAdjustmentKeys } from "../entity";
import HeaderCatalogPageComponent from "../../../components/templates/headerCatalogPageUpdated";
export var StockAdjustmentList = function () {
    var navigate = useNavigate();
    var _a = useAppSelector(function (state) { return state.crud; }), getStockAdjustmentList = _a.getStockAdjustmentList, stockAdjustmentPaging = _a.stockAdjustmentPaging;
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var crud = useAppSelector(function (state) { return state.crud; });
    var listVariants = ["My Adjustment", "All Adjustment"];
    var _b = useState('list'), activeView = _b[0], setActiveView = _b[1];
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var _c = useState(listVariants.length > 0 && isAllViewActive ? listVariants[1] : listVariants[0]), selectedListVariant = _c[0], setSelectedListVariant = _c[1];
    var storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE);
    var request = {
        TenantId: selectedBranch.OrganizationId,
        ParentTenantId: selectedBranch.ParentOrganizationId,
        RequistionType: "Adjustment"
    };
    useEffect(function () {
        var request = {
            TenantId: selectedBranch.OrganizationId,
            ParentTenantId: selectedBranch.ParentOrganizationId,
            RequistionType: "Adjustment"
        };
        if (selectedListVariant === "My Adjustment") {
            var _crud$profilePersonal;
            request.IdentityId = crud === null || crud === void 0 || (_crud$profilePersonal = crud.profilePersonalDetails) === null || _crud$profilePersonal === void 0 || (_crud$profilePersonal = _crud$profilePersonal.data) === null || _crud$profilePersonal === void 0 ? void 0 : _crud$profilePersonal.IdentityId;
        }
        StockAdjustmentPaging({
            key: StockAdjustmentKeys.paging,
            request: request,
            url: stockAdjustmentPagingAPI
        });
    }, [selectedListVariant]);
    var handleSelectMenu = function (listVariant) {
        setSelectedListVariant(listVariant);
    };
    var onToggleViewChange = function (value) {
        setActiveView(value);
    };
    var onClickCreateModule = function () {
        navigate("/createStockAdjustment?mode=add");
    };
    var getIcon = function (name) {
        switch (name) {
            case 'Print':
                return /*#__PURE__*/ React.createElement(PrintIconSVG, {
                    id: "stockTransferRequi-print-icon",
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            case 'DownloadPDF':
                return /*#__PURE__*/ React.createElement(DownloadIconSVG, {
                    id: "stockTransferRequi-print-icon",
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            case 'Share':
                return /*#__PURE__*/ React.createElement(ShareOutlinedIconSVG, {
                    id: "stockTransferRequi-share-icon",
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            case 'Cancel':
                return /*#__PURE__*/ React.createElement(CancelIconSVG, {
                    id: "stockTransferRequi-cancel-icon",
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            case 'Edit':
                return /*#__PURE__*/ React.createElement(EditIconSVG, {
                    id: "stockTransferRequi-cancel-icon",
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            default:
                return /*#__PURE__*/ React.createElement(React.Fragment, null);
        }
    };
    var customActionColumns = [{
            field: 'DocumentNumber',
            headerName: 'Document number',
            valueFormatter: function (val) { return val !== null && val !== void 0 ? val : '-'; },
            minWidth: 150
        }, {
            field: 'DocumentDate',
            headerName: 'Document date',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.CreatedOn ? "".concat(dateFormate(dayjs(row === null || row === void 0 ? void 0 : row.CreatedOn))) : '-'; },
            minWidth: 150
        }, {
            field: 'Location',
            headerName: 'Location',
            valueFormatter: function (val, row) {
                var _row$Location$Name, _row$Location;
                return (_row$Location$Name = row === null || row === void 0 || (_row$Location = row.Location) === null || _row$Location === void 0 ? void 0 : _row$Location.Name) !== null && _row$Location$Name !== void 0 ? _row$Location$Name : '-';
            },
            minWidth: 150
        }, {
            field: 'TotalAdjustment',
            headerName: 'Total adjustment',
            valueFormatter: function (val) { return val !== null && val !== void 0 ? val : '-'; },
            minWidth: 150
        }, {
            field: 'AdjustmentQty',
            headerName: 'Adjustment qty',
            valueFormatter: function (val) { return val !== null && val !== void 0 ? val : '-'; },
            minWidth: 150
        }, {
            field: 'AdjustmentValue',
            headerName: 'Adjustment value',
            valueFormatter: function (val) { return val !== null && val !== void 0 ? val : '-'; },
            minWidth: 150
        }, {
            field: 'AdjustedBy',
            headerName: 'Adjusted by',
            valueFormatter: function (val, row) {
                var _row$RecordedByGivenN, _row$RecordedByFamily;
                return row !== null && row !== void 0 && row.RecordedByGivenName || row !== null && row !== void 0 && row.RecordedByFamilyName ? "".concat((_row$RecordedByGivenN = row === null || row === void 0 ? void 0 : row.RecordedByGivenName) !== null && _row$RecordedByGivenN !== void 0 ? _row$RecordedByGivenN : ' ', "  ").concat((_row$RecordedByFamily = row === null || row === void 0 ? void 0 : row.RecordedByFamilyName) !== null && _row$RecordedByFamily !== void 0 ? _row$RecordedByFamily : ' ') : '-';
            },
            minWidth: 150
        }, {
            field: 'StatusName',
            headerName: 'Status',
            minWidth: 150,
            renderCell: function (params) {
                var _params$row, _params$row$Statuses$, _params$row2;
                return (params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 || (_params$row = _params$row.Statuses) === null || _params$row === void 0 ? void 0 : _params$row.Name) && /*#__PURE__*/ React.createElement(Chip, {
                    label: (_params$row$Statuses$ = params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 || (_params$row2 = _params$row2.Statuses) === null || _params$row2 === void 0 ? void 0 : _params$row2.Name) !== null && _params$row$Statuses$ !== void 0 ? _params$row$Statuses$ : '-',
                    size: "small",
                    variant: "outlined",
                    sx: {
                        borderRadius: 2,
                        px: 1,
                        fontWeight: 500,
                        fontSize: 12,
                        color: 'black'
                    },
                    icon: /*#__PURE__*/ React.createElement(Box, {
                        height: 8,
                        width: 8,
                        borderRadius: 10,
                        bgcolor: "gray"
                    })
                });
            }
        }, {
            type: 'actions',
            field: 'actions',
            headerName: '',
            getActions: function (params) {
                var _storedMenuFeatures$f, _storedMenuFeatures$f2;
                return (_storedMenuFeatures$f = storedMenuFeatures === null || storedMenuFeatures === void 0 || (_storedMenuFeatures$f2 = storedMenuFeatures.filter(function (data) {
                    var _params$row3;
                    if ((data === null || data === void 0 ? void 0 : data.Name) === 'SendForApproval' && (params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.StatusName) !== 'Draft') {
                        return false;
                    }
                    return true;
                })) === null || _storedMenuFeatures$f2 === void 0 ? void 0 : _storedMenuFeatures$f2.map(function (data) { /*#__PURE__*/ return React.createElement(GridActionsCellItem, {
                    key: data === null || data === void 0 ? void 0 : data.Name,
                    label: data === null || data === void 0 ? void 0 : data.DisplayName,
                    icon: getIcon(data === null || data === void 0 ? void 0 : data.Name),
                    showInMenu: true
                }); })) !== null && _storedMenuFeatures$f !== void 0 ? _storedMenuFeatures$f : [];
            },
            flex: 1
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DesktopTabComponent, {
        items: listVariants
    }), /*#__PURE__*/ React.createElement(HeaderCatalogPageComponent, {
        selectedMenuItem: selectedListVariant,
        menus: listVariants.length > 0 ? listVariants : undefined,
        onSelectMenu: handleSelectMenu,
        activeView: activeView,
        onToggleView: onToggleViewChange,
        totalCount: getStockAdjustmentList === null || getStockAdjustmentList === void 0 ? void 0 : getStockAdjustmentList.TotalCount,
        onClickCreateModule: onClickCreateModule,
        createButtonText: "New",
        isCreateButton: true,
        moduleName: ESystemName.StockAdjustment,
        title: "Stock Adjustment"
    }), /*#__PURE__*/ React.createElement(Box, {
        p: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        getPagingData: StockAdjustmentPaging,
        pagingAPIKey: StockAdjustmentKeys.paging,
        pagingAPIRequest: request,
        columns: customActionColumns
    })));
};
